import { render } from "./AccessSettingsSection.vue?vue&type=template&id=7adc3a36"
import script from "./AccessSettingsSection.vue?vue&type=script&lang=js"
export * from "./AccessSettingsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__